export const Prices = [
    {
        _id:0,
        name:"0 - 150,000 د.ع",
        array:[0,150000]
    },
    {
        _id:1,
        name:"150,000 - 300,000 د.ع",
        array:[150000,300000]
    },
    {
        _id:2,
        name:"300,000 - 500,000 د.ع",
        array:[300000,500000]
    },
    {
        _id:3,
        name:"500,000 - 750,000 د.ع",
        array:[500000,750000]
    },
    {
        _id:4,
        name:"750,000 - 1,000,000 د.ع",
        array:[750000,1000000]
    },
    {
        _id:5,
        name:"1,000,000 - 2,000,000 د.ع",
        array:[1000000,2000000]
    },
    {
        _id:6,
        name:"أكثر من 2,000,000 د.ع",
        array:[2000000,99999999]
    },
];
